module.exports = __webpack_public_path__ + "img/start.794f3b32.png";